import { createModel } from "nyax";
import { CoeToDoWork, CoeToDoWorkQuery } from "src/models/coeToDoWork";
import { CoeToDoWorkEntityModel } from "src/store/models/entity/coeToDoWork/entity";
import { createUISideListWithPermissionModel } from "src/store/models/ui/_shared";

export const CoeToDoWorkSideUIModel = createModel(
  class extends createUISideListWithPermissionModel<
    CoeToDoWork,
    CoeToDoWorkQuery
  >({
    setItems: (getContainer, items) =>
      getContainer(CoeToDoWorkEntityModel).actions.setItems.dispatch(items),
    getItems: (getContainer) =>
      getContainer(CoeToDoWorkEntityModel).getters.items,
    getItem: (getContainer, id) =>
      getContainer(CoeToDoWorkEntityModel).state.byId[id],
    getItemId: (item) => item.id,
  }) {
    public effects() {
      return {
        ...super.effects(),
        initial: async (payload: { departmentId: string }) => {
          const { departmentId } = payload;
          this._initial({
            initialAction: (
              pageIndex: number,
              pageSize: number,
              query: CoeToDoWorkQuery
            ) =>
              this.dependencies.serviceClient.coeWork.toDoList(
                departmentId,
                pageIndex,
                pageSize,
                query
              ),
          });
        },
      };
    }
  }
);
